/**
 * Sprint 5-a · CostMeter · 費用透明度（sticky bottom·always visible）。
 * 「應答就計費」原則：任何時候都讓使用者看見本次 session 已消耗的 tokens 與費用。
 */
import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
  sessionTokens: number;
  sessionCost: number;
  currency?: string;
  monthlyUsed?: number;
  monthlyQuota?: number;
}

const CostMeter: React.FC<Props> = ({ sessionTokens, sessionCost, currency = 'USD', monthlyUsed, monthlyQuota }) => {
  const { t } = useTranslation();
  const tt = (k: string, d: string) => t(`agentic.${k}`, d);
  const pct = monthlyQuota ? Math.min(100, ((monthlyUsed || 0) / monthlyQuota) * 100) : 0;
  return (
    <Box sx={{
      position: 'sticky', bottom: 0, zIndex: 2, bgcolor: 'background.paper',
      borderTop: '1px solid', borderColor: 'divider', px: 1.25, py: 0.75,
      display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap',
    }}>
      <Typography variant="caption" color="text.secondary">
        {tt('costThis', '本次')}:{' '}
        <strong>{sessionTokens.toLocaleString()}</strong> tokens ·{' '}
        <strong>${sessionCost.toFixed(4)}</strong> {currency}
      </Typography>
      {monthlyQuota != null && (
        <>
          <Typography variant="caption" color="text.secondary">
            {tt('costMonth', '本月')}:{' '}
            {(monthlyUsed || 0).toLocaleString()} / {monthlyQuota.toLocaleString()}
          </Typography>
          <LinearProgress variant="determinate" value={pct} sx={{ flex: 1, minWidth: 60, height: 6, borderRadius: 3 }} />
        </>
      )}
    </Box>
  );
};

export default CostMeter;
